import ConsoleUI from './consoleUI';

import ConsoleTerminal from './consoleTerminal';
import ConsoleRCon from './consoleRCon';
import ConsoleParent from './consoleParent';
import ConsoleArk from './consoleArk';

const ENV_TERMINAL = 'terminal';
const ENV_RCON = 'rcon';
const BASE_SELECTOR: string = '[data-console]';

class ConsoleFactory {

    private environment = '';

    constructor() {
        if (typeof window.consoleUrl !== 'undefined') {
            this.environment = ENV_RCON;
            return;
        }
        if (typeof window.socketURL !== 'undefined') {
            this.environment = ENV_TERMINAL;
            return;
        }
        throw ('Console type cannot be detected');
    }

    public getInstance(el: JQuery): ConsoleParent {
        switch (this.environment) {
            case ENV_TERMINAL:
                return new ConsoleTerminal(el, window.socketURL);
            case ENV_RCON:
                console.log(window.ajaxPath);
                if (window.ajaxPath.match(/\/ark-se\//)) {
                    return new ConsoleRCon(el, window.consoleUrl);

    //                return new ConsoleArk(el, window.consoleUrl);

                }
                return new ConsoleRCon(el, window.consoleUrl);
        }
    }
}

export function initConsole(): void {

    let factory = new ConsoleFactory();
    $(BASE_SELECTOR).each((i, el) => {
        factory.getInstance($(el))
    });
}
